"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChargerControlChargingPowerLimitCommandSerialization = void 0;
class ChargerControlChargingPowerLimitCommandSerialization {
    static serialize(entity) {
        const copy = { ...entity };
        return JSON.stringify(copy);
    }
    static deserialize(msg) {
        const entity = JSON.parse(msg);
        const copy = { ...entity };
        return copy;
    }
}
exports.ChargerControlChargingPowerLimitCommandSerialization = ChargerControlChargingPowerLimitCommandSerialization;
